export const Roles = {
  ADMIN: "Admin",
  ACCOUNT_MANAGER: "Account Manager",
  DIY_ACCOUNT: "DIY Account",
  DIY_BRAND: "DIY Brand",
  DIY_PARTNER: "DIY Partner",
  PARTNER_MANAGER: "Partner Manager",
  TRANSLATOR: "Translator",
  PARTNER: "Partner",
  ACCOUNT: "Account",
  SALES_MANAGER: "Sales",
  CREATIVE: "Creative",
  FINANCE: "Finance",
  SITE:"Site",
  MANAGED_BRAND:"Managed Brand"
};
